import React from "react";

export const FilterIcon = (props: React.SVGProps<SVGSVGElement> & {size?: number | string}) => (
  <svg {...props} className={props.className} width={props.size || 30} height={props.size || 30} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29 36.9V24L39.2 9.4c1-1.6-.2-3.7-2-3.7H12.9c-1.8 0-3 2-2 3.7l10 14.6v19.4M28.9 37c-3.2.7-6.1 3-7.9 6.2" stroke="CurrentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);